import { jsx as r } from "react/jsx-runtime";
import p from "classnames";
import { forwardRef as d } from "react";
import i from "./index.es824.js";
import { v4 as h } from "uuid";
import { UnifiedInputField as u } from "./index.es62.js";
import { Icon as F } from "./index.es157.js";
const a = "search-field", I = `${a}-component`, A = d(
  ({
    size: t = "default",
    disabled: e,
    testId: l = I,
    fullWidth: m = !1,
    onClick: s,
    id: f = `${a}-${h()}`,
    onKeyDown: c,
    ...o
  }, n) => /* @__PURE__ */ r(
    "div",
    {
      className: p(i.searchField, {
        [i["search--full-width"]]: m
      }),
      children: /* @__PURE__ */ r(
        u,
        {
          ...o,
          id: f,
          disabled: e,
          testId: l,
          onClick: s,
          RightIcon: /* @__PURE__ */ r(F, { type: "MagnifyingGlass", disabled: e, size: 24 }),
          ref: n,
          size: t,
          onKeyDown: c,
          "aria-label": o["aria-label"] || "Please Fill out your search query"
        }
      )
    }
  )
);
export {
  a as PASSWORD_FIELD_ID,
  I as SEARCH_FIELD_DEFAULT_TESTID,
  A as SearchField
};
//# sourceMappingURL=index.es45.js.map
